// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

const SECRET_KEY = ".G(hX02.*!EYs$~"; // TODO: yarışma id ile birleştirecek şekilde ayarlıcaz
const _0x5aa9 = ["", "\x6C\x65\x6E\x67\x74\x68", "\x63\x68\x61\x72\x43\x6F\x64\x65\x41\x74", "\x66\x72\x6F\x6D\x43\x68\x61\x72\x43\x6F\x64\x65"];
export default class StorageService {
  static set<T>(key: string, value: T): void {
    const plainText = JSON.stringify(value);
    localStorage.setItem(key, StorageService.encrypt(plainText, SECRET_KEY));
  }

  static get<T>(key: string): T | null {
    // localStorage.getItem(key) null döner ise Uncaught (in promise) TypeError: Cannot read properties of null (reading 'length') hatası alıyoruz.
    const storedValue = localStorage.getItem(key);
    if (!storedValue) {
      return null;
    }
    try {
      return JSON.parse(StorageService.decrypt(storedValue, SECRET_KEY)) as T;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  static delete(key: string): void {
    localStorage.removeItem(key);
  }


  static encrypt(_0xbfc5x2, _0xbfc5x3): string {
    let _0xbfc5x4 = _0x5aa9[0];
    for (let _0xbfc5x5 = 0; _0xbfc5x5 < _0xbfc5x2[_0x5aa9[1]]; _0xbfc5x5++) {
      const _0xbfc5x6 = _0xbfc5x2[_0x5aa9[2]](_0xbfc5x5) ^ _0xbfc5x3[_0x5aa9[2]](_0xbfc5x5 % _0xbfc5x3[_0x5aa9[1]]);
      _0xbfc5x4 += String[_0x5aa9[3]](_0xbfc5x6)
    }

    return _0xbfc5x4
  }

  static decrypt(_0xbfc5x4, _0xbfc5x3): string {
    let _0xbfc5x2 = _0x5aa9[0];
    for (let _0xbfc5x5 = 0; _0xbfc5x5 < _0xbfc5x4[_0x5aa9[1]]; _0xbfc5x5++) {
      const _0xbfc5x6 = _0xbfc5x4[_0x5aa9[2]](_0xbfc5x5) ^ _0xbfc5x3[_0x5aa9[2]](_0xbfc5x5 % _0xbfc5x3[_0x5aa9[1]]);
      _0xbfc5x2 += String[_0x5aa9[3]](_0xbfc5x6)
    }

    return _0xbfc5x2
  }

}
